import React, { useRef, useCallback } from 'react';
import TimerMachine from 'react-timer-machine';
import * as moment from 'moment';
import momentDurationFormatSetup from 'moment-duration-format';

import { useFight } from '../../hooks/Fight';

momentDurationFormatSetup(moment);

interface TimeRef {
  h: number;
  m: number;
  s: number;
  ms: number;
}

interface StopwatchProps {
  start: boolean;
  pause: boolean;
  onComplete?(): void;
  style?: React.CSSProperties;
}

const FightStopwatch: React.FC<StopwatchProps> = ({ start, pause, style }) => {
  const { dispatchFight, fight } = useFight();

  const timeRef = useRef<TimeRef>();
  
  // const [, updateState] = useState();
  // const forceUpdate = useCallback(() => updateState(undefined), []);

  // useEffect(() => forceUpdate, [forceUpdate]);

  const handleTick = useCallback((time: Timer) => {
    timeRef.current = time;

    dispatchFight({
      type: 'time',
      time: {
        currentMinutes: timeRef.current?.m || 0,
        currentSeconds: timeRef.current?.s || 0,
      },
    });
  }, [dispatchFight]);

  const formatTimer = useCallback((time: Timer, ms: number) => {
    return moment.duration(ms, 'milliseconds').format('h:mm:ss');
  }, []);

  return (
    <div style={style}>
      <TimerMachine
        timeStart={
          ((fight.currentMinutes || 0) * 60 + (fight.currentSeconds || 0)) *
          1000
        }
        timeEnd={1800 * 1000}
        started={start}
        paused={pause}
        countdown={false}
        interval={1000}
        formatTimer={formatTimer}
        onTick={handleTick}
      />
    </div>
  );
};

export default FightStopwatch;
